import { Flex, Image, Link, useToast } from '@chakra-ui/react'
import React, { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { prefixes } from '@core/utils/helpers/prefixes'

const formatPhoneNumber = (prefixStr: string | undefined | null = '', phone: string): string => {
    let cleaned = phone.replace(/\s+/g, '')
    if (prefixStr && cleaned.startsWith(prefixStr + prefixStr)) {
        cleaned = cleaned.replace(prefixStr + prefixStr, prefixStr)
    }
    const prefixLength = prefixStr && prefixStr?.length > 0 ? prefixStr.length - 1 : 0
    const regex = new RegExp(`(\\+\\d{${prefixLength}})(\\d+)`)
    if (prefixLength > 0) {
        return cleaned.replace(regex, '$1 $2')
    }
    return cleaned.replace(regex, '$1$2')
}

const baseClass = 'ContactPerson__contact-link'

interface PersonContactLinkProps {
    type?: 'tel' | 'mailto'
    value: string
    phonePrefix?: string | null
}

const PersonContactLink: FC<PersonContactLinkProps> = ({ type = 'mailto', value, phonePrefix = '' }) => {
    const toast = useToast()
    const { t } = useTranslation()

    const findPrefix = () => {
        return prefixes.find(({ prefix }) => `${phonePrefix || ''}${value}`.startsWith(prefix))
    }

    const prefixItem = type === 'tel' ? findPrefix() : null

    const formatedPhone = formatPhoneNumber(prefixItem?.prefix, `${phonePrefix || ''}${value}`)

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(type === 'tel' ? formatedPhone.replace(/\s/g, '') : value)
            toast({
                title: t('6272'),
                description: type === 'tel' ? formatedPhone : value,
                status: 'success',
                duration: 2000,
                isClosable: true,
            })
        } catch (error) {
            console.log('Copy error:', error)
            toast({
                title: t('3875'),
                description: type === 'tel' ? formatedPhone : value,
                status: 'error',
                duration: 2000,
                isClosable: true,
            })
        }
    }

    return (
        <Flex className={baseClass} fontSize={'sm'} gap={'8px'}>
            {type === 'tel' && (
                <Image
                    src={`${
                        process.env.ENV === 'local' ? process.env.API_URL : window.location.origin
                    }/${prefixItem?.code}`}
                    fallbackSrc={''}
                    maxW={4}
                />
            )}
            <Link
                href={`${type}:${type === 'tel' ? formatedPhone.replace(/\s/g, '') : value}`}
                // display={'block'}
                maxW={'208px'}
                overflow={'hidden'}
                whiteSpace={'nowrap'}
                textOverflow={'ellipsis'}
                alignItems={'center'}
                gap={'8px'}
                fontWeight={'semibold'}
                color={'#1A1A1A'}
                _hover={{ textDecoration: 'none', cursor: 'pointer' }}
            >
                {formatedPhone}
            </Link>
            <i className="fa-regular fa-clone ContactPerson__modal__icon" onClick={handleCopy}></i>
        </Flex>
    )
}

export default PersonContactLink
